import { useId } from 'react'
import type { ReactNode, TextareaHTMLAttributes } from 'react'
import { Icon } from '../Icon/Icon'
import { cx } from '../utils/cx'
import './Input.css'

export interface TextareaProps extends Omit<TextareaHTMLAttributes<HTMLTextAreaElement>, 'children'> {
  label: ReactNode
  labelNote?: ReactNode
  help?: ReactNode
  error?: ReactNode
}

/** Área de texto con las mismas reglas que Input (etiqueta visible, ayuda/error sin mover el layout). */
export function Textarea({ label, labelNote, help, error, id, className, rows = 3, ...rest }: TextareaProps) {
  const uid = useId()
  const inputId = id ?? `hp-textarea-${uid}`
  const noteId = `${inputId}-note`
  const note = error ?? help
  return (
    <div className={cx('hp-field', error && 'hp-field--error', className)}>
      <label htmlFor={inputId} className="hp-field__label">
        {label}
        {labelNote && <span className="hp-field__label-note"> {labelNote}</span>}
      </label>
      <div className="hp-field__control hp-field__control--textarea">
        <textarea id={inputId} rows={rows} className="hp-field__input hp-field__textarea" aria-invalid={error ? true : undefined} aria-describedby={note ? noteId : undefined} {...rest} />
      </div>
      <div id={noteId} className="hp-field__note" aria-live={error ? 'polite' : undefined}>
        {error ? (
          <>
            <Icon name="alert-triangle" size={18} className="hp-field__note-icon" />
            <span>{error}</span>
          </>
        ) : (
          note
        )}
      </div>
    </div>
  )
}
